import React, { useEffect, useState } from "react";
import { Grid, Box, Button, IconButton, Modal, Typography } from "../../components/ui";
import { Add, Delete, Edit } from "../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { modalStyle } from "../../style/common";
import MarriageForm from "./components/MarriageForm";
// import BlockFrom from "./components/BlockFrom";

const Marriage = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [marriage, setMarriage] = useState<any>([]);
  const [id, setId] = useState<any>(null);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleGetMarriage();
    setId(null);
  };

  const handleGetMarriage = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/marriage`);
      if (resp?.status === 200) {
        setMarriage(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleDelete = async (id: any) => {
    try {
      const resp: any = await axiosInstance.delete(`/api/marriage/${id}`);
      if (resp?.status === 200) {
        handleGetMarriage();
        toast.success("Deleted successfully");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetMarriage();
  }, []);
  
  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }}>
        <Grid size={12}>
          <Button onClick={handleOpen} sx={{ textTransform: "none" }}>
            <Typography fontSize={20} fontWeight={500} color="#111827">
              Marriage
              <IconButton onClick={handleOpen}>
                <Add sx={{ color: "#111827" }} />
              </IconButton>
            </Typography>
          </Button>
        </Grid>
        <Grid
          size={12}
          container
          mt={2}
          py={1}
          bgcolor={"#111827"}
          borderRadius={1}
          color={"whitesmoke"}
        >
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Sl no
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Husband
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Wife
            </Typography>
          </Grid>
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Solemnized Date
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Solemnized Place
            </Typography>
          </Grid>{" "}
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Dissolution Date
            </Typography>
          </Grid>{" "}
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Is Dissolved
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Action
            </Typography>
          </Grid>
        </Grid>
        {marriage?.map((item: any, index: any) => (
          <Grid size={12} container borderBottom={"1px solid #111827"} py={2}>
            <Grid size={1}>
              <Typography fontSize={17} align="center">
                {" "}
                {index + 1}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.man?.name}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.woman?.name}
              </Typography>
            </Grid>
            <Grid size={1}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.solemnized_date}{" "}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.solemnized_place}
              </Typography>
            </Grid>{" "}
            <Grid size={1}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.dissolution_date}{" "}
              </Typography>
            </Grid>{" "}
            <Grid size={1}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.is_dissolved ? "Dissolved" : "Not Dissolved"}
              </Typography>
            </Grid>
            <Grid
              size={2}
              sx={
                item?.is_request_send && {
                  pointerEvents: "none",
                  opacity: 0.6,
                }
              }
            >
              <Typography fontSize={17} align="center">
                <IconButton
                  onClick={() => {
                    setId(item?.id);
                    handleOpen();
                  }}
                >
                  <Edit sx={{ color: "#111827" }} />
                </IconButton>
                <IconButton onClick={() => handleDelete(item?.id)}>
                  <Delete sx={{ color: "#111827" }} />
                </IconButton>
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <MarriageForm onClose={handleClose} id={id} />
          {/* <BlockFrom onClose={handleClose} id={id} /> */}
        </Box>
      </Modal>
    </div>
  );
};

export default Marriage;
